import { render, staticRenderFns } from "./BestOfferConfigurationText.vue?vue&type=template&id=b676e4e6&scoped=true"
import script from "./BestOfferConfigurationText.vue?vue&type=script&lang=js"
export * from "./BestOfferConfigurationText.vue?vue&type=script&lang=js"
import style0 from "./BestOfferConfigurationText.vue?vue&type=style&index=0&id=b676e4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b676e4e6",
  null
  
)

export default component.exports